var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.674,
    height: 11.805,
    viewBox: "0 0 9.674 11.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13414",
    "data-name": "Group 13414",
    transform: "translate(-4807.819 -1277.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7696",
    "data-name": "Path 7696",
    d: "M4826.1,1318.081v.994c0,1.911,0,4.518,0,6.43a1.416,1.416,0,0,1-1.569,1.57q-2.572,0-5.144,0a1.415,1.415,0,0,1-1.572-1.567c0-2.12,0-4.935,0-7.055v-.372Zm-6.606,4.816q0,1.181,0,2.362c0,.27.1.459.405.441s.352-.245.352-.5c0-1.528,0-3.752,0-5.28,0-.271-.058-.5-.389-.494s-.37.251-.369.514C4819.491,1320.7,4819.49,1322.144,4819.49,1322.9Zm2.087,0q0,1.181,0,2.362c0,.27.1.459.405.441s.351-.245.351-.5c0-1.528,0-3.752,0-5.28,0-.271-.058-.5-.389-.493s-.369.251-.369.514C4821.578,1320.7,4821.576,1322.145,4821.577,1322.9Zm2.086-.02c0,.776,0,1.551,0,2.327,0,.27.054.5.387.5.31,0,.371-.219.371-.477,0-1.54,0-3.775,0-5.315,0-.257-.059-.475-.369-.479-.332,0-.389.224-.388.495C4823.664,1320.677,4823.663,1322.125,4823.663,1322.877Z",
    transform: "translate(-9.299 -37.582)",
    fill: "#9dacbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7697",
    "data-name": "Path 7697",
    d: "M4812.657,1279.756c-1.356,0-2.712,0-4.068,0a.687.687,0,1,1-.04-1.367c.579-.009,1.159-.01,1.738,0a.385.385,0,0,0,.434-.247.738.738,0,0,1,.753-.453q1.182,0,2.364,0a.738.738,0,0,1,.753.452.385.385,0,0,0,.433.249c.567-.013,1.136-.008,1.7,0,.477,0,.757.253.765.668.008.431-.277.7-.768.7C4815.368,1279.759,4814.013,1279.756,4812.657,1279.756Z",
    transform: "translate(0 0)",
    fill: "#9dacbd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTag);
export default __webpack_public_path__ + "static/media/delete-tag.8178991762e1c045ee11beea9a4fa576.svg";
export { ForwardRef as ReactComponent };